import Customer from './Customer';

export default Customer;


// WEBPACK FOOTER //
// ./src/views/Customer/index.js